module.exports = __webpack_public_path__ + "static/media/grundfos-logo.38d778ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/forside/grundfos-logo.jpg
// module id = 1472
// module chunks = 0